export default __webpack_public_path__ + "static/media/p63.8f704b21.jpg";